const actions = {
  GET_BENEFITS_AND_PAYMENTS: "GET_BENEFITS_AND_PAYMENTS",
  GET_BENEFITS_AND_PAYMENTS_SUCCESS: "GET_BENEFITS_AND_PAYMENTS_SUCCESS",
  GET_BENEFITS_AND_PAYMENTS_ERROR: "GET_BENEFITS_AND_PAYMENTS_ERROR",

  getBenefitsAndPayments: data => ({
    type: actions.GET_BENEFITS_AND_PAYMENTS,
    data
  })
};

export default actions;
